import { render, staticRenderFns } from "./BannedWordsList.vue?vue&type=template&id=6dd5ed1f&scoped=true&"
import script from "./BannedWordsList.vue?vue&type=script&lang=js&"
export * from "./BannedWordsList.vue?vue&type=script&lang=js&"
import style0 from "./BannedWordsList.vue?vue&type=style&index=0&id=6dd5ed1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5ed1f",
  null
  
)

export default component.exports